import type { Provider } from '@angular/core';
import type { Client } from '@bugsnag/browser';
import Bugsnag from '@bugsnag/js';

import { SESSION_ID } from '@accesso/cc-std-lib';

import type { IEnvironmentService } from '../../core/environment/environment.interface';
import { EnvironmentService } from '../../core/environment/environment.service';
import { APP_VERSION } from '../../version';
import { MerchantStore } from '../merchant/merchant.store';
import { BUGSNAG_API_KEY, BugsnagClient } from './bugsnag.client';

export const provideBugsnagBrowserClient = (): Provider => {
	return {
		provide: BugsnagClient,
		useFactory: bugsnagProviderFactory,
		deps: [BUGSNAG_API_KEY, SESSION_ID, MerchantStore, EnvironmentService],
	};
};

function bugsnagProviderFactory(
	apiKey: string,
	sessionId: string,
	merchantStore: InstanceType<typeof MerchantStore>,
	{ env, isProduction }: IEnvironmentService
): Client {
	const merchant = merchantStore.merchant();
	const store = merchantStore.store();
	const PRODUCTION_ENV_NAME = 'production';

	return Bugsnag.start({
		apiKey,
		appVersion: APP_VERSION,
		appType: 'client',
		maxBreadcrumbs: 100,
		maxEvents: 100,
		redactedKeys: [/(password|address|name|token|phone|email)/i, 'middleInitial', 'city', 'state', 'region', 'postalCode'],
		enabledReleaseStages: [PRODUCTION_ENV_NAME],
		releaseStage: isProduction ? PRODUCTION_ENV_NAME : env,
		metadata: {
			ClientConfig: {
				sessionId,
				merchantId: merchant?.id,
				storeId: store?.id,
				language: store?.language,
			},
		},
	});
}
